import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { assetsUrl, apiUrl } from "../config/config";
import Overlay from '../components/Overlay';
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import Spinner from "react-activity/dist/Spinner";
import { getRoundedDiscountPercent, roundNumber } from "../utils/price";

const Cart = () => {
  const customerdata = useSelector((store) => store.userReducer.customerdata);
  const cartdata = useSelector((store) => store.userReducer.cartdata);
  console.log('cart cartdata >>', cartdata);
  const [cart, setcart] = useState([]);
  const cartRef = useRef();
  cartRef.current = cart;
  const [totalprice, settotalprice] = useState(0);
  const [allcouponsdata, setallcouponsdata] = useState([]);
  const [couponcode, setcouponcode] = useState("");
  const [coupondiscountamount, setcoupondiscountamount] = useState(0);
  const [selectedcouponname, setselectedcouponname] = useState(null);
  const [selectedcouponvalue, setselectedcouponvalue] = useState(0);
  const [shippingcharges, setshippingcharges] = useState(0);
  const [showloading, setshowloading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch(); 

  const [showmodal, setshowmodal] = useState(false);

  const handlechangequantity = (index, quantity) => {
    if(quantity < 1) {

    } else {
      console.log('index >>', index);
    console.log('quantity >>', quantity);
    var prevdata = cartRef.current?.map(item => ({...item}));
    console.log('before prevdata >>', prevdata);
    prevdata[index]['quantity'] = parseInt(quantity);


    console.log('after prevdata >>', prevdata);

    setcart(prevdata);
    var totalPrice = prevdata.reduce((acc, item) => {
      return acc + item?.price * parseInt(item?.quantity);
    }, 0);
    settotalprice(totalPrice);
    dispatch({ type: "cartdata", payload: prevdata });
    
    // setcouponcode("");
    // setcoupondiscountamount(0);
    //           setselectedcouponname(null);
    //           setselectedcouponvalue(0);
    setTimeout(() => {
      if(coupondiscountamount > 0) {
        applycoupon()
      }
      
    }, 1000);
    
    }
    
  }

  

  const handleremovecartitem = (index) => {
    var prevdata = cartRef.current?.map(item => ({...item}));
    prevdata.splice(index, 1);
    setcart(prevdata);
    var totalPrice = prevdata.reduce((acc, item) => {
      return acc + item?.price * parseInt(item?.quantity);
    }, 0);
    settotalprice(totalPrice);
    dispatch({ type: "cartdata", payload: prevdata });
  }

  const handleplaceorder = async() => {
    // console.log('customerdata >>', customerdata);
    if(customerdata && Object.keys(customerdata)?.length > 0) {
      
      
      if(cartRef.current?.length > 0) {
        setshowloading(true);
        var data = {
          cartdata: cartRef.current
        }
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + customerdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "checkcartstock",data, headers)
          .then((res) => {
              // console.log('res >>', res?.data)
              if(res?.data?.status == 'success') {
                var prevdata = res?.data?.data;
                var showwarning = false;
                for(var i = 0; i < prevdata?.length; i++) {
                  if(prevdata[i].stock < prevdata[i].quantity) {
                    showwarning = true;
                  }
                }
                if(showwarning) {
                  alert("Some products are out of stock. Please remove the product from cart");
                  console.log('prevdata >>', prevdata);
                dispatch({ type: "cartdata", payload: prevdata });
                setcart(prevdata);
                } else {
                  console.log('prevdata >>', prevdata);
                dispatch({ type: "cartdata", payload: prevdata });
                setcart(prevdata);
                let passdata = { coupondiscountamount: coupondiscountamount, promotionid:  selectedcouponname, promotionvalue: selectedcouponvalue, shippingcharges: shippingcharges};
                navigate('/checkout', {state: passdata});
                }
                
                // setcart(prevdata);
              } else {
                if(res?.data?.message == 'invalid user') {
                  let passdata = { fromscreen: 'cart' };
                  navigate('/login', {state: passdata});
                } else {
                  alert(res?.data?.message);
                }
              }
              
              
          }).catch((err) => {
            alert(err.message);
          });
          setshowloading(false);
      } else {

      }

      // navigate('/checkout', {state: passdata});
    } else {
      // console.log('not logged in');
      let passdata = { fromscreen: 'cart' };
      navigate('/login', {state: passdata});
    }
  }

  const applycoupon = async() => {
    var data = {
      code: couponcode,
      device: 'web'
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
      .post(apiUrl + "applycoupon",data, headers)
      .then((res) => {
          // console.log('res >>', res?.data)
          if(res?.data?.data?.length > 0) {
            var percent = res?.data?.data[0]?.discountValue;
            // var currenttotal = totalprice;
            var prevdata = cartRef.current?.map(item => ({...item}));
            var eligibleamountarr = [];
            for(var i = 0; i < prevdata?.length; i++) {
              if(res?.data?.data[0]?.category == null && res?.data?.data[0]?.subcategory == null && res?.data?.data[0]?.category_product_name == null) {
                if(res?.data?.data[0]?.mincartvalue > 0) {
                  //min cart value function
                } else {
                  eligibleamountarr.push(prevdata[i]?.price * prevdata[i]?.quantity);
                }
                
              } else if(prevdata[i]?.category == res?.data?.data[0]?.category ||
                prevdata[i]?.subcategory == res?.data?.data[0]?.subcategory ||
                prevdata[i]?.slug == res?.data?.data[0]?.category_product_name
              ) {
                // eligibleamountarr.push(prevdata[i]?.price);
                if(res?.data?.data[0]?.category_product_name == null) {
                  if(res?.data?.data[0]?.subcategory == null) {
                    if(prevdata[i]?.category == res?.data?.data[0]?.category) {
                      eligibleamountarr.push(prevdata[i]?.price * prevdata[i]?.quantity);
                    } else {
                       // not applicable
                    }
                  } else if (prevdata[i]?.subcategory == res?.data?.data[0]?.subcategory) {
                    eligibleamountarr.push(prevdata[i]?.price * prevdata[i]?.quantity);
                  } else {
                    // not applicable
                  }
                } else if(res?.data?.data[0]?.category_product_name) {
                  var productsarr = res?.data?.data[0]?.category_product_name?.split(',');
                  console.log('productsarr >>', productsarr);
                  if(productsarr.includes(prevdata[i]?.slug)) {
                    eligibleamountarr.push(prevdata[i]?.price * prevdata[i]?.quantity);
                  }
                  
                } else {
                  // not applicable
                }
              } else {

              }
            }
            console.log('eligibleamountarr >>>', eligibleamountarr);
            if(eligibleamountarr?.length > 0) {
              var currenttotal = eligibleamountarr.reduce((a, b) => a + b, 0);
              console.log('currenttotal >>', currenttotal);
              var discountamount = parseInt((percent * currenttotal) / 100);
              setcoupondiscountamount(discountamount);
              setselectedcouponname(res?.data?.data[0]?.id);
              setselectedcouponvalue(res?.data?.data[0]?.discountValue);
            } else {
              if(res?.data?.data[0]?.mincartvalue > 0 && res?.data?.data[0]?.mincartvalue < totalprice) {
                var discountamount = parseInt((percent * totalprice) / 100);
              setcoupondiscountamount(discountamount);
              setselectedcouponname(res?.data?.data[0]?.id);
              setselectedcouponvalue(res?.data?.data[0]?.discountValue);
              } else {
                var currenttotal = 0
              setcoupondiscountamount(0);
              setselectedcouponname(null);
              setselectedcouponvalue(0);
              }
              // var currenttotal = 0
              // setcoupondiscountamount(0);
              // setselectedcouponname(null);
              // setselectedcouponvalue(0);
            }
            
          } else {
            setcoupondiscountamount(0);
            setselectedcouponname(null);
            setselectedcouponvalue(0);
          }
          
      }).catch((err) => {
        alert(err.message);
      });
  }

  const fetchallgeneralcoupons = async() => {
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
      .get(apiUrl + "getallcartpromotion?device=web", headers)
      .then((res) => {
          // console.log('res >>', res?.data)
          if(res?.data?.allcoupons?.length > 0) {
            setallcouponsdata(res?.data?.allcoupons);
          } else {
            setallcouponsdata([]);
          }
      }).catch((err) => {
        alert(err.message);
      });
  }

  const checkshippingcharges = async(total) => {
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    var data = {
      'amount': total
    }
    let resp = await axios
      .post(apiUrl + "getshippingcharges",data, headers)
      .then((res) => {
          // console.log('res >>', res?.data)
          if(res?.data?.status == 'success') {
            setshippingcharges(res?.data?.amount);
          } else {
            setshippingcharges(0);
          }
          // if(res?.data?.allcoupons?.length > 0) {
          //   setallcouponsdata(res?.data?.allcoupons);
          // } else {
          //   setallcouponsdata([]);
          // }
      }).catch((err) => {
        alert(err.message);
      });
  }

  const handleclickapplyfrommodal = async(code) => {
    setcouponcode(code);
    setshowmodal(false);
    var data = {
      code: code,
      device: 'web'
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
      .post(apiUrl + "applycoupon",data, headers)
      .then((res) => {
          // console.log('res >>', res?.data)
          if(res?.data?.data?.length > 0) {
            var percent = res?.data?.data[0]?.discountValue;
            // var currenttotal = totalprice;
            var prevdata = cartRef.current?.map(item => ({...item}));
            var eligibleamountarr = [];
            for(var i = 0; i < prevdata?.length; i++) {
              if(res?.data?.data[0]?.category == null && res?.data?.data[0]?.subcategory == null && res?.data?.data[0]?.category_product_name == null) {
                if(res?.data?.data[0]?.mincartvalue > 0) {
                  //min cart value function
                } else {
                  eligibleamountarr.push(prevdata[i]?.price * prevdata[i]?.quantity);
                }
                
              } else if(prevdata[i]?.category == res?.data?.data[0]?.category ||
                prevdata[i]?.subcategory == res?.data?.data[0]?.subcategory ||
                prevdata[i]?.slug == res?.data?.data[0]?.category_product_name
              ) {
                // eligibleamountarr.push(prevdata[i]?.price);
                if(res?.data?.data[0]?.category_product_name == null) {
                  if(res?.data?.data[0]?.subcategory == null) {
                    if(prevdata[i]?.category == res?.data?.data[0]?.category) {
                      eligibleamountarr.push(prevdata[i]?.price * prevdata[i]?.quantity);
                    } else {
                       // not applicable
                    }
                  } else if (prevdata[i]?.subcategory == res?.data?.data[0]?.subcategory) {
                    eligibleamountarr.push(prevdata[i]?.price * prevdata[i]?.quantity);
                  } else {
                    // not applicable
                  }
                } else if(res?.data?.data[0]?.category_product_name) {
                  var productsarr = res?.data?.data[0]?.category_product_name?.split(',');
                  console.log('productsarr >>', productsarr);
                  if(productsarr.includes(prevdata[i]?.slug)) {
                    eligibleamountarr.push(prevdata[i]?.price * prevdata[i]?.quantity);
                  }
                  
                } else {
                  // not applicable
                }
              } else {

              }
            }
            console.log('eligibleamountarr >>>', eligibleamountarr);
            if(eligibleamountarr?.length > 0) {
              var currenttotal = eligibleamountarr.reduce((a, b) => a + b, 0);
              console.log('currenttotal >>', currenttotal);
              var discountamount = parseInt((percent * currenttotal) / 100);
              setcoupondiscountamount(discountamount);
              setselectedcouponname(res?.data?.data[0]?.id);
              setselectedcouponvalue(res?.data?.data[0]?.discountValue);
            } else {
              if(res?.data?.data[0]?.mincartvalue > 0 && res?.data?.data[0]?.mincartvalue < totalprice) {
                var discountamount = parseInt((percent * totalprice) / 100);
              setcoupondiscountamount(discountamount);
              setselectedcouponname(res?.data?.data[0]?.id);
              setselectedcouponvalue(res?.data?.data[0]?.discountValue);
              } else {
                var currenttotal = 0
              setcoupondiscountamount(0);
              setselectedcouponname(null);
              setselectedcouponvalue(0);
              }
              // var currenttotal = 0
              // setcoupondiscountamount(0);
              // setselectedcouponname(null);
              // setselectedcouponvalue(0);
            }
            
          } else {
            setcoupondiscountamount(0);
            setselectedcouponname(null);
            setselectedcouponvalue(0);
          }
          
      }).catch((err) => {
        alert(err.message);
      });
    
  }

  

  const feedarrs = async() => {
    // setcart(cartdata);
    // console.log('test >>>>>>>>>', cartdata);
    var prevdata = cartdata;
    var newarrobj = [];
    var productids = [];
    for(var i = 0; i < prevdata?.length > 0; i++) {
      var cartobj = {
        id: prevdata[i]?.id,
        name: prevdata[i]?.name,
        cartimage: prevdata[i]?.cartimage,
        price: prevdata[i]?.price,
        quantity: prevdata[i]?.quantity,
        category: prevdata[i]?.category,
        subcategory: prevdata[i]?.subcategory,
        slug: prevdata[i]?.slug,
        stock: prevdata[i]?.stock,
        discountpercent: prevdata[i]?.discountpercent,
        ogprice: prevdata[i]?.ogprice
      }
      productids.push(prevdata[i]?.id);
      newarrobj.push(cartobj)
    }

    // setcart(newarrobj);

    var data = {
      ids: productids,
      device: "web"
    }
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
      .post(apiUrl + "checkcartproductsprice",data, headers)
      .then((res) => {
        // console.log('res >>', res?.data?.data['12244']);
        var fetcheddata = res?.data?.data;
        var newarr = [];
        for(var i = 0; i < newarrobj?.length;i++) {
         
          var obj = {
            ...newarrobj[i],
            name: fetcheddata[newarrobj[i]?.id]["name"],
            price: roundNumber(fetcheddata[newarrobj[i]?.id]["price"]),
            ogprice: roundNumber(fetcheddata[newarrobj[i]?.id]["ogprice"]),
            discountpercent: getRoundedDiscountPercent(fetcheddata[newarrobj[i]?.id]["discount_percent"])
          }
         
         newarr.push(obj);
        }
        setcart(newarr);
        dispatch({ type: "cartdata", payload: newarr });
      })
      .catch((err) => {
        alert(err.message);
      });
    // Calculate Total price
  }

  useEffect(() => {
    if(totalprice > 0) {
      checkshippingcharges(totalprice)
    } else {
      setshippingcharges(0)
    }
  }, [totalprice])

  useEffect(() => {
    fetchallgeneralcoupons();
  }, [])

  useEffect(() => {
    feedarrs();
    
    
  }, [])

  useEffect(() => {
    if(cartRef.current?.length > 0) {
      var newarrobj = cartRef.current;
      console.log('called >>', cartRef.current);
      var totalPrice = newarrobj.reduce((acc, item) => {
        return acc + item?.price * parseInt(item?.quantity);
      }, 0);
      settotalprice(totalPrice);
    } else {

    }
  }, [cartRef.current])
  return (
    <>
      <section className="mt-5 mb-3">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
            <h5 className="mb-4 carthead">Cart ({cart?.length} item)</h5>
            {
              cartRef.current?.length > 0 ?
              cartRef.current?.map((item, index) => {
                // console.log('item >>', item)
                return (
                  <div className="productcartdetails">

                <div className="card-body dflex dblock">
                  <div className="viewimg">
                    <img
                      src={assetsUrl+"products/"+item?.cartimage}
                      className="img-fluid w-100"
                    />
                  </div>

                  <div className="dflex space-between w100">
                    <div className="cartcontent">
                      <h5 className="cart_title">{item?.name}</h5>
                      <p className="small uppercase">
                        PRICE - ₹{item?.price}
                        {item?.discountpercent > 0 ? (
                          <>
                            {" "}
                            <span className="clr">
                              <s>₹{item?.ogprice}</s>
                            </span>
                            <span className="offer">
                              {" "}
                              {item?.discountpercent}% off
                            </span>
                          </>
                        ) : null}
                      </p>
                      <p className="small uppercase">SHIPPING - 0</p>

                      <div style={{cursor: 'pointer'}} onClick={() => {handleremovecartitem(index)}}>
                        <p className="small mt-2" style={{color: 'red'}}>
                          <i className="fa fa-trash mr-1" style={{fontSize: 20}}></i>
                         <span style={{marginLeft: 7, fontSize: 17}}>Remove Item</span>
                        </p>
                      </div>
                      {
                      item.hasOwnProperty('stock') && parseInt(item?.stock) < 1 ?
                        <div className="dflex mt-2 dblock">
                  <span className="soldoutbtn" style={{backgroundColor: '#e61513', color: '#fff', fontSize: 15
                  }} >SOLD OUT</span> 
                  </div> : null
                      }
                    </div>
                    <div className="text-right">
                      {
                        item?.id == '1236200000000' ?
                        <input
                      type="text"
                        value={item?.quantity}
                        defaultValue={item?.quantity}
                        // onChange={(t) => {handlechangequantity(index, t.target.value)}}
                        className="quantitynumber"
                      /> : 
                      <input
                      type="number"
                        value={item?.quantity}
                        defaultValue={item?.quantity}
                        onChange={(t) => {handlechangequantity(index, t.target.value)}}
                        className="quantitynumber"
                      />
                      }
                      
                      <p className="small mb-2">(Note, 1 piece)</p>
                      <p className="">Total ₹{item?.price * item?.quantity} </p>
                    </div>
                  </div>
                </div>
              </div>
                )
              }) : null
            }
              
            </div>

            <div className="col-md-4">
            <h5 className="mb-4">&nbsp; </h5>
              <div className="productcartdetails">
                <h5 className="mb-4">Price Details</h5>
                <div className="dflex space-between mb-3">
                  <p className="fs16 weight600">Price ({cart?.length} items)</p>
                  <p className="fs16 weight600">₹{totalprice}</p>
                </div>

                <div className="dflex space-between">
                  <p className="fs16 weight600">Shipping Charges</p>
                  <p className="fs16 weight600">₹ {shippingcharges}</p>
                </div>

                <div className="space-between mt-3">
                  <div className="d-flex" style={{justifyContent: 'space-between'}}>
                    <p className="fs16 weight600 mb-2">Apply Promocode:</p>
                    {
                      allcouponsdata?.length > 0 ?
                      <div className="" style={{cursor: 'pointer'}} onClick={() => {setshowmodal(true)}}>
                      <p className="fs16 weight600 mb-2" style={{color: '#17a2b8'}}>All Offers</p>
                    </div> : 
                    null
                    }
                    
                  </div>
                  <div className="d-flex">
                  <input
                    type="text"
                    value={couponcode}
                    onChange={(t) => {
                      setcouponcode(t.target.value)
                    }}
                    className="form-control cartinput"
                    placeholder="Apply Promocode"
                  />
                  {
                    couponcode?.length > 0 ?
                    <button className="cta-apply cta-applycoupon ajustwidthcart" onClick={() => {
                      applycoupon()
                     }}>Apply</button> : 
                     <button className="cta-apply ajustwidthcart">Apply</button>
                  }
                  </div>
                  
                  
                  {
                    coupondiscountamount > 0 ?
                    <span className="text-green">Coupon Code Applied</span> : null
                  }
                  {/* <span className="text-green">Coupon Code Not Applied</span> */}
                </div>

                {/* <div className="mt-3">
                  {
                    couponcode?.length > 0 ?
                    <button className="cta-apply cta-applycoupon" onClick={() => {
                      applycoupon()
                     }}>Apply</button> : 
                     <button className="cta-apply">Apply</button>
                  }
                   
                </div> */}
                
                {
                  coupondiscountamount > 0 ?
                  <div className="dflex space-between mt-3">
                  <p className="fs16 weight600">Coupon Discount</p>
                  <p className="fs16 weight600">- ₹{coupondiscountamount}</p>

                </div> : null
                }
               

                <div className="dflex space-between mt-2">
                  <p className="fs16 weight600">Total Amount</p>
                  <p className="fs16 weight600">₹{parseInt(totalprice + shippingcharges - coupondiscountamount).toFixed(2)}</p>

                </div>

                <div className="mt-3">
                   <button className="cta-danger place-order-btn" onClick={() => {
                    handleplaceorder();
                   }}>
                    {
                      showloading ?
                      <Spinner color='#fff' size={16} className='spinnerCenter1' style={{marginTop: 0}} /> :
                      "Place Order"
                    }
                    
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Coupons modal */}
    <Modal
              show={showmodal}
              onHide={() => setshowmodal(false)}
              size="md"
              className="custom-width-modal"
            >
              <Modal.Header closeButton>
                <Modal.Title style={{fontSize: 19}}>Coupons</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="webadmin-modalmainbody">
                  {
                    allcouponsdata?.length > 0 ?
                    allcouponsdata?.map((item, index) => {
                      // console.log('item >>', item)
                      return (
                        <>
                          <div className="couponsrow">
                          <p className="coupontitle">{item?.promotionName}</p>
                          <p className="couponcode">Use Coupon code : <b>{item?.promocode}</b></p>
                          <p className="coupondescription">
                          {item?.description}
                          </p>
                          <div className="applycouponbtn" onClick={() => {handleclickapplyfrommodal(item?.promocode)}}>
                            <p>Apply</p>
                          </div>
                        </div>
                        </>
                        
                      );
                    })
                    
                     :
                    <p className="fs16 weight600">No Offers</p>
                  }
                </div>
              </Modal.Body>
            </Modal>
    </>
  );
};

export default Cart;
